import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

export const settingsBreadcrumbs = generateBreadcrumbs({
  label: 'GLOBAL.NAVS.SETTINGS',
  route: { name: 'settings' },
});
